import { render, staticRenderFns } from "./KeywordsToUseCollapse.vue?vue&type=template&id=201e69a2&scoped=true&"
import script from "./KeywordsToUseCollapse.vue?vue&type=script&lang=js&"
export * from "./KeywordsToUseCollapse.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsToUseCollapse.vue?vue&type=style&index=0&id=201e69a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e69a2",
  null
  
)

/* custom blocks */
import block0 from "./KeywordsToUseCollapse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports